import { GET_STATE_LIST_LOAD, GET_STATE_LIST_LOAD_SUCCESS, SAVE_STATE_OBJECT, GET_STATE_LIST_LOAD_FAIL, GET_STORE_LIST_LOAD, GET_STORE_LIST_LOAD_SUCCESS, GET_STORE_LIST_LOAD_FAIL, SHOW_OVERLAY, HIDE_OVERLAY, SET_THEME_DATA, SET_SELECTED_THEME_UID, SET_SELECTED_IMAGE_1, SET_SELECTED_IMAGE_2, SET_EVENT_DATE_VALUE, SET_EVENT_TXT_VALUE , SET_EVENT_COMMENT,  CLEAR_EVENT_PERSONALIZATION,  } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  dataState: [],
  dataStore: [],
  extraData: {},
  isColorPickerOpen: false,
  themeData:[],
  selectedThemeUid: null,
  selectedImage1: "",
  selectedImage2: "",
  eventTxtValue: "",
  eventDateValue: "",
  eventComment: "",
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_STATE_LIST_LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_STATE_LIST_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        dataState: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_STATE_LIST_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        dataState: null,
        error: action.error,
      };
    case GET_STORE_LIST_LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_STORE_LIST_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        dataStore: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_STORE_LIST_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        dataStore: null,
        error: action.error,
      };
    case SAVE_STATE_OBJECT: {
      return Object.assign({}, state, { data: action.data });
    }
    case SHOW_OVERLAY:
      return { ...state, isColorPickerOpen: true };
    case HIDE_OVERLAY:
      return { ...state, isColorPickerOpen: false };
    case SET_THEME_DATA:
      return { ...state, themeData: action.payload };
    case SET_SELECTED_THEME_UID:
      return {
        ...state,
        selectedThemeUid: action.payload,
      };
    case SET_SELECTED_IMAGE_1:
      return {
        ...state,
        selectedImage1: action.payload
      };
    case SET_SELECTED_IMAGE_2:
      return {
        ...state,
        selectedImage2: action.payload
      };
    case SET_EVENT_COMMENT:
      return {
        ...state,
        eventComment: action.payload
      };
    case SET_EVENT_TXT_VALUE:
      return {
        ...state,
        eventTxtValue: action.payload
      };
    case SET_EVENT_DATE_VALUE:
      return {
        ...state,
        eventDateValue: action.payload
      };
    case CLEAR_EVENT_PERSONALIZATION:
      return {
        ...state,
        eventTxtValue: '',
        eventDateValue: '',
        selectedImage1: '',
        selectedImage2: '',
        eventComment: '',
        selectedThemeUid: '',
        themeData: [],
      };
    default:
      return state;
  }
}
